import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

import { IconButton } from '../../common/components/IconButton'
export const STableContainer = styled.div`
    width: 100%;
    overflow: auto;
    height: 62vh;
    scroll-behavior: smooth;
`

export const STable = styled.table`
    table-layout: fixed;
    width: 100%;
    margin-bottom: 20px;

    border-collapse: separate;
    border-spacing: 0;
    background-color: transparent;

    &::-webkit-scrollbar {
        display: none;
    }

    @media (max-width: 900px) {
        table-layout: auto;
    }
`

export const STableHead = styled.th<{ centered?: boolean; width?: number }>`
    border-bottom: 1px solid #ddd;
    position: sticky;
    top: 0;
    background-color: #fff;
    padding: 8px;
    font-size: 14px;
    font-weight: var(--font-weight-bold);
    color: ${({ theme }) => theme.font.midDarkColor};
    text-align: ${({ centered }) => (centered ? 'center' : 'left')};
    width: ${({ width }) => (width ? `${width}px` : 'unset')};
    a {
        cursor: pointer;
    }
    z-index: 10;
`

export const STableBody = styled.tbody``

export const STableRow = styled.tr`
    background-color: #ffff;

    &:last-child > td {
        border-bottom: none;
    }
`

export const SJsonCopyButton = styled(IconButton)`
    position: absolute;
    top: 10px;
    z-index: 1;
    left: 80px;
    visibility: hidden;
    padding: 4px;
    border-radius: 50%;
`

export const STableCell = styled.td`
    padding: 8px;
    vertical-align: top;
    border-bottom: 1px solid #ddd;
    font-weight: var(--font-weight-light);
    font-size: 14px;
    overflow-wrap: break-word;
    position: relative;

    &:hover > ${SJsonCopyButton} {
        visibility: visible;
    }
`

export const SIcon = styled(FontAwesomeIcon)`
    color: #337ab7;
    cursor: pointer;
    &:hover {
        color: #23527c;
    }
`

export const STableActions = styled.div`
    display: flex;
    justify-content: center;
    background-color: #ffff;
    padding: 20px;
`

export const SheadingPopup = styled.div`
    width: 100%;
    min-width: 300px;
    font-weight: var(--font-weight-bold);
    display: flex;
    flex-direction: row;
    margin-bottom: 4px;
    justify-content: space-between;
`
